import { render, staticRenderFns } from "./CarBuyersGuide.vue?vue&type=template&id=c99fa358&scoped=true"
import script from "./CarBuyersGuide.vue?vue&type=script&lang=js"
export * from "./CarBuyersGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99fa358",
  null
  
)

export default component.exports